import React from 'react';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiGift,FiPlay,FiFileText,FiBarChart,FiVideo}=FiIcons;

const BonusSection=()=> {
  const bonuses=[
    {icon: FiPlay,title: "VDO Bazi Startup Course: Bazi Foundations",value: "8,900.-",description: "สำหรับท่านที่ยังไม่เคยเรียน The Bazi Blueprint มาก่อน ไม่ต้องกังวลครับ! ผมเตรียม VDO ปูพื้นฐานฉบับเร่งรัด (Intensive) ไว้ให้คุณดูจบก่อนมาเรียนจริง",condition: "เงื่อนไข: จำเป็นต้องดูให้จบก่อนเข้าคลาส เพื่อประโยชน์สูงสุดของคุณเอง"},
    {icon: FiFileText,title: "Toxic People Radar Checklist",value: "3,500.-",description: "เช็คลิสต์ลับสำหรับสแกน \"คนอันตราย\" 5 ประเภท (คนโกง,คนตอแหล,คนแทงข้างหลัง) แค่มีแผ่นนี้คุณจะมองคนออกทะลุปุโปร่งภายใน 5 นาทีแรกที่คุยกัน"},
    {icon: FiBarChart,title: "The Team Synergy Chart (PDF)",value: "5,900.-",description: "ตารางจับคู่ธาตุฉบับผู้บริหาร: ใครคู่ใครแล้วรุ่ง? ใครคู่ใครแล้วพัง? ใช้จัดทีมงาน (HR) หรือหาหุ้นส่วนธุรกิจให้แมตช์กับดวงคุณแบบวิทยาศาสตร์"},
    {icon: FiVideo,title: "Exclusive VDO Case Study: Love & War",value: "4,500.-",description: "คลิปวิเคราะห์เจาะลึกดวงคู่รักคนดังและหุ้นส่วนระดับโลก ทำไมคู่รักคู่นี้เลิกกัน? ทำไมหุ้นส่วนคู่นี้รวยล้นฟ้า? (เรียนรู้จากเคสจริง เจ็บจริง รวยจริง)"}
  ];

  return (
    <section className="py-20 px-4 relative">
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-emerald-900/10 to-transparent"></div>
      <div className="relative z-10 max-w-6xl mx-auto">
        <motion.div
          initial={{y: 30,opacity: 0}}
          whileInView={{y: 0,opacity: 1}}
          transition={{duration: 0.8}}
          viewport={{once: true}}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            <span className="bg-gradient-to-r from-emerald-400 to-teal-400 bg-clip-text text-transparent">
              BONUS STACK
            </span>
          </h2>
          <h3 className="text-2xl md:text-3xl font-semibold text-white mb-4">
            อาวุธเสริมความสัมพันธ์ที่ผม<span className="text-emerald-400">มอบให้ฟรี</span>
          </h3>
          <p className="text-lg text-gray-300 max-w-3xl mx-auto">
            "ผมไม่ได้แค่ขายคอร์ส... แต่ผมต้องการให้คุณเอาไปใช้งานได้จริง"
          </p>
          <div className="mt-8 bg-slate-800/30 backdrop-blur-sm border border-emerald-500/30 rounded-2xl p-6 max-w-4xl mx-auto">
            <p className="text-gray-300">
              เพื่อให้แน่ใจว่า คุณจะเดินออกจากห้องเรียนไปพร้อมกับ <span className="text-emerald-400 font-semibold">"ชัยชนะ"</span> ในทุกความสัมพันธ์
            </p>
            <p className="text-gray-300 mt-2">
              ผมได้เตรียม เครื่องมือ (Tools) และ ทางลัด (Shortcuts) มูลค่าสูงไว้ให้คุณตามนี้ครับ:
            </p>
          </div>
        </motion.div>

        <div className="grid lg:grid-cols-2 gap-8">
          {bonuses.map((bonus,index)=> (
            <motion.div
              key={index}
              initial={{y: 50,opacity: 0}}
              whileInView={{y: 0,opacity: 1}}
              transition={{duration: 0.8,delay: index * 0.1}}
              viewport={{once: true}}
              className="group"
            >
              <div className="bg-slate-800/50 backdrop-blur-sm border border-slate-700/50 rounded-2xl p-6 h-full hover:border-emerald-500/50 transition-all duration-300 hover:shadow-2xl hover:shadow-emerald-500/10">
                <div className="flex items-start mb-4">
                  <div className="w-12 h-12 bg-gradient-to-br from-emerald-500 to-teal-500 rounded-full flex items-center justify-center mr-4 flex-shrink-0 group-hover:scale-110 transition-transform duration-300">
                    <SafeIcon icon={bonus.icon} className="text-xl text-white" />
                  </div>
                  <div className="flex-1">
                    <div className="flex items-center mb-2">
                      <span className="text-2xl mr-2">🎁</span>
                      <span className="text-emerald-400 font-bold">BONUS #{index + 1}:</span>
                    </div>
                    <h4 className="text-xl font-bold text-white mb-2">
                      "{bonus.title}"
                    </h4>
                    <div className="bg-gradient-to-r from-emerald-500/20 to-teal-500/20 rounded-lg px-3 py-1 inline-block mb-4">
                      <span className="text-emerald-300 font-semibold">
                        มูลค่า {bonus.value}
                      </span>
                    </div>
                  </div>
                </div>
                <p className="text-gray-300 leading-relaxed mb-4">
                  {bonus.description}
                </p>
                {bonus.condition && (
                  <div className="bg-yellow-500/10 border border-yellow-500/30 rounded-lg p-3">
                    <p className="text-yellow-300 text-sm">
                      {bonus.condition}
                    </p>
                  </div>
                )}
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{y: 30,opacity: 0}}
          whileInView={{y: 0,opacity: 1}}
          transition={{duration: 0.8,delay: 0.6}}
          viewport={{once: true}}
          className="text-center mt-16"
        >
          <div className="bg-gradient-to-r from-emerald-500/20 to-teal-500/20 backdrop-blur-sm border border-emerald-500/30 rounded-2xl p-8 max-w-4xl mx-auto">
            <h4 className="text-2xl md:text-3xl font-bold text-white mb-4">
              รวมมูลค่าโบนัสทั้งหมด: <span className="text-emerald-400">22,800 บาท</span>
            </h4>
            <p className="text-lg text-gray-300 mb-6">
              แต่คุณได้รับ<span className="text-emerald-400 font-semibold"> ฟรี</span> เมื่อสมัครวันนี้!
            </p>
            <button className="group relative px-8 py-4 bg-gradient-to-r from-emerald-500 to-teal-600 text-white font-bold text-lg rounded-full shadow-2xl hover:shadow-emerald-500/25 transition-all duration-300 transform hover:scale-105 border border-emerald-400/50">
              <span className="flex items-center space-x-2">
                <SafeIcon icon={FiGift} className="text-xl" />
                <span>รับโบนัสครบชุด + เรียนเก่งขาด!</span>
              </span>
              <div className="absolute inset-0 bg-gradient-to-r from-emerald-600 to-teal-700 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300 -z-10"></div>
            </button>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default BonusSection;